<template>
  <div id="video"></div>
</template>

<script>
export default {
  props: ["url", "lecture", "upperDisplay"],
  computed: {
    learningLecture() {
      return this.$store.getters.learningLecture;
    },
  },
  data: () => {
    return {
      currentTraceTime: 0,
      videoProgressTime: 0,
    };
  },
  beforeDestroy() {
    this.clearPlayer();
  },
  methods: {
    clearPlayer() {
      try {
        window.jwplayer("video").remove();
      } catch (err) {
        console.log(err);
      }
    },
    sendUpdateTimeToCourseList(time) {
      let id = this.lecture._id;
      this.$store.commit("updateVideoTime", {
        id,
        time,
      });
    },
    renderJwplayer(url) {
      const seekTime = this.videoCurrentTime(this.upperDisplay);
      -window.jwplayer("video").setup({
        sources: [
          {
            file: url,
          },
        ],
        playbackRateControls: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
      });
      window.jwplayer().seek(seekTime / 1000);
      setTimeout(() => {
        window.jwplayer().on("time", (event) => {
          const position = (event ? event : {}).position;
          const truncTime = Math.trunc(position);
          // this.$store.commit("updateVideoCurrentTime", truncTime * 1000);
          // const cycleLog = this.upperDisplay.cycle_log | 5;
          const cycleLog = 10;
          // const isFiveTimesRecord =
          //   truncTime > this.currentTraceTime && truncTime % cycleLog === 0;
          const isFiveTimesRecord = truncTime % cycleLog === 0;
          const isNew = truncTime > this.currentTraceTime;
          // if(event.duration === event.position){
          //   const payload = {
          //     key: this.upperDisplay.key,
          //     videoCurrentTime:  * 1000
          //   };
          //   this.$store.dispatch("saveVideoTime", payload);
          //   return;
          // }
          if (isFiveTimesRecord && isNew) {
            const payload = {
              key: this.upperDisplay.key,
              currenttime: truncTime * 1000,
              _id: this.lecture._id,
            };
            this.currentTraceTime = truncTime;
            this.$store.dispatch("closeVideo", payload);
            this.updateTimeCondition(truncTime);
          }
        });
      }, 1000);
      window.jwplayer().on("seek", (event) => {
        const position = (event ? event : {}).offset;
        const truncTime = Math.trunc(position);
        const payload = {
          key: this.upperDisplay.key,
          currenttime: truncTime * 1000,
          _id: this.lecture._id,
        };
        this.currentTraceTime = truncTime;
        this.$store.dispatch("closeVideo", payload);
        this.updateTimeCondition(truncTime);

        // if (event.offset > this.currentTraceTime + 5) {
        //   window.jwplayer("video").seek(20);
        // }
      });
      window.jwplayer().on("complete", (event) => {
        this.$store.dispatch("closeVideo", {
          key: this.upperDisplay.key,
          currenttime: this.upperDisplay.videoTime,
          _id: this.lecture._id,
        });
        this.$store.dispatch("fetchSections", this.$store.getters.courseId);
      });
    },
    videoCurrentTime(upperDisplay) {
      if (
        this.upperDisplay.videoCurrentTime &&
        this.upperDisplay.videoCurrentTime !== this.upperDisplay.videoTime
      ) {
        let rewindVideo = this.upperDisplay.videoCurrentTime - 10000
        if(rewindVideo > 0){
          return rewindVideo;
        }
        else {
          return 0
        }
        // } else {
        //   return this.upperDisplay.videoCurrentTime;
        // }
      }
      return 0;
    },
    updateVideoProgressTime(time) {
      this.videoProgressTime = time;
    },
    updateTimeCondition(truncTime) {
      // if (truncTime * 1000 > this.videoProgressTime) {
      this.sendUpdateTimeToCourseList(truncTime * 1000);
      this.updateVideoProgressTime(truncTime * 1000);
      // }
    },
  },
  mounted() {
    this.updateVideoProgressTime(this.upperDisplay.videoTime);
    this.renderJwplayer(this.url);
  },
  watch: {
    url(newUrl) {
      this.renderJwplayer(newUrl);
    },
  },
};
</script>
